const TOKEN_KEY = 'token'
const USER_KEY = 'current_user'
const REMEMBERED_USERNAME_KEY = 'remembered_username'
const NEED_CHANGE_PASSWORD_KEY = 'need_change_password'

export function getToken() {
  return localStorage.getItem(TOKEN_KEY) || ''
}

export function setToken(token) {
  localStorage.setItem(TOKEN_KEY, String(token || ''))
}

export function removeToken() {
  localStorage.removeItem(TOKEN_KEY)
}

export function getCurrentUser() {
  const raw = localStorage.getItem(USER_KEY)
  if (!raw) return null
  try {
    return JSON.parse(raw)
  } catch {
    return null
  }
}

export function setCurrentUser(user) {
  localStorage.setItem(USER_KEY, JSON.stringify(user || {}))
}

export function removeCurrentUser() {
  localStorage.removeItem(USER_KEY)
}

export function getNeedChangePassword() {
  return localStorage.getItem(NEED_CHANGE_PASSWORD_KEY) === '1'
}

export function setNeedChangePassword(value) {
  if (value) localStorage.setItem(NEED_CHANGE_PASSWORD_KEY, '1')
  else localStorage.removeItem(NEED_CHANGE_PASSWORD_KEY)
}

export function getCurrentUserRole() {
  const user = getCurrentUser()
  return String(user?.role || '').trim().toLowerCase()
}

export function clearAuth() {
  removeToken()
  removeCurrentUser()
  setNeedChangePassword(false)
}

export function getRememberedUsername() {
  return localStorage.getItem(REMEMBERED_USERNAME_KEY) || ''
}

export function setRememberedUsername(username) {
  localStorage.setItem(REMEMBERED_USERNAME_KEY, String(username || ''))
}

export function removeRememberedUsername() {
  localStorage.removeItem(REMEMBERED_USERNAME_KEY)
}
